import { eventDetails } from './content'
import { Arrow } from './ui'
import { useViewportVideo } from './useViewportVideo'
import VideoSoundControl from './VideoSoundControl'
import VideoPoster from './VideoPoster'

export default function WorldStage() {
  const { error, videoProps, previewProps, controlsProps } = useViewportVideo('/images/wellness-world-poster.jpg')

  return <section className="world-stage world-stage--film" id="world-stage" aria-labelledby="world-title">
    <div className="world-stage-inner">
      <div className="world-stage-intro">
        <p className="world-stage-eyebrow">TOP 12 FROM THAILAND TO THE WORLD STAGE</p>
        <h2 id="world-title">จากเวทีประเทศไทย<br /><em>สู่เวทีโลก</em></h2>
      </div>

      <figure className="world-film" aria-labelledby="world-film-title">
        <div className="world-film-frame">
          <video {...videoProps} width="720" height="1280" aria-label="วิดีโอแนะนำเวที MISS WELLNESS WORLD">
            <source src="/videos/wellness-world.mp4" type="video/mp4" />
            เบราว์เซอร์นี้ไม่รองรับวิดีโอ <a href="/videos/wellness-world.mp4">เปิดวิดีโอ MISS WELLNESS WORLD</a>
          </video>
          <VideoPoster {...previewProps} />
        </div>
        <VideoSoundControl {...controlsProps} />
        <figcaption><div><span>THE WORLD STAGE</span><strong id="world-film-title">MISS WELLNESS WORLD</strong></div><a href="/videos/wellness-world.mp4" target="_blank" rel="noopener noreferrer" aria-label="เปิดวิดีโอ MISS WELLNESS WORLD ในแท็บใหม่"><Arrow /></a></figcaption>
        {error && <p className="world-film-error" role="alert">ยังไม่สามารถเล่นวิดีโอได้ ลองกดเล่นจากแถบควบคุม หรือ <a href="/videos/wellness-world.mp4" target="_blank" rel="noopener noreferrer">เปิดวิดีโอโดยตรง</a></p>}
      </figure>

      <div className="world-stage-details">
        <div className="world-finalists"><span className="world-finalists-number">12</span><p>WORLD STAGE<br />FINALISTS</p><span className="world-finalists-rule" aria-hidden="true" /></div>
        <p className="world-stage-description">ผู้เข้ารอบ 12 คนสุดท้ายของ EMPRESS OF WELLNESS จะได้รับเกียรติขึ้นเวที <strong>MISS WELLNESS WORLD</strong> ร่วมพิธีประกาศตำแหน่งและรับรางวัลของ EMPRESS OF WELLNESS บนเวทีระดับโลก</p>
        <div className="world-stage-event"><time dateTime="2026-09-27">27 SEPTEMBER 2026</time><strong>{eventDetails.worldVenue}</strong><span>ร่วมเวทีกับตัวแทนจากกว่า 40 ประเทศ</span></div>
        <p className="world-stage-quote">จากผู้หญิงคนหนึ่ง สู่เสียงที่อาจสร้างแรงบันดาลใจ<br />ให้ผู้หญิงอีกนับพันคน</p>
        <a className="world-stage-link" href="#timeline">ดูเส้นทางของคุณ <Arrow /></a>
      </div>
    </div>
  </section>
}
